export default __webpack_public_path__ + "static/media/ads.a4146332.jpg";